var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const SvgFacebook = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: size || 24, height: size || 24, viewBox: "0 0 24 24", role: props.role, "aria-hidden": props['aria-hidden'] || true }, props),
        React.createElement("path", { fill: props.color || 'currentColor', fillRule: "evenodd", d: "M9.21567432,22.9090909 L9.21567432,12.4532258 L7,12.4532258 L7,8.85048541 L9.21567432,8.85048541 L9.21567432,6.68752152 C9.21567432,3.74858277 10.4660977,2 14.0209307,2 L16.9796789,2 L16.9796789,5.60406004 L15.1304613,5.60406004 C13.7465962,5.60406004 13.6551514,6.10751991 13.6551514,7.04713571 L13.6490551,8.85048541 L17,8.85048541 L16.6078033,12.4532258 L13.6490551,12.4532258 L13.6490551,22.9090909 L9.21567432,22.9090909 Z" })));
};
export default SvgFacebook;
